(function () {
  'use strict';

  var banner = document.getElementById('cookies-model');
  if (!banner) return;

  var acceptButton = banner.querySelector('[data-cookie-accept]');
  var rejectButton = banner.querySelector('[data-cookie-reject]');
  var privacyApi = null;
  // Preserve an explicit choice made while loadFeatures is still pending,
  // including when localStorage is blocked. Do not replay stale stored consent.
  var pendingConsent = null;
  var fallbackConsentKey = 'homeax_cookie_consent';

  function showBanner() {
    banner.hidden = false;
    banner.style.display = 'block';
  }

  function hideBanner() {
    banner.hidden = true;
    banner.style.display = 'none';
  }

  function setButtonsDisabled(disabled) {
    if (acceptButton) acceptButton.disabled = disabled;
    if (rejectButton) rejectButton.disabled = disabled;
  }

  function saveFallbackConsent(allowed) {
    try {
      window.localStorage.setItem(fallbackConsentKey, allowed ? 'accepted' : 'rejected');
    } catch (error) {
      // Consent can still be applied through Shopify when storage is unavailable.
    }
  }

  function hasFallbackConsent() {
    try {
      var choice = window.localStorage.getItem(fallbackConsentKey);
      return choice === 'accepted' || choice === 'rejected';
    } catch (error) {
      return false;
    }
  }

  function hasShopifyConsentDecision() {
    if (!privacyApi || typeof privacyApi.currentVisitorConsent !== 'function') return false;

    var consent = privacyApi.currentVisitorConsent();
    return ['analytics', 'marketing', 'preferences'].some(function (purpose) {
      return consent && (consent[purpose] === 'yes' || consent[purpose] === 'no');
    });
  }

  function saveConsent(allowed) {
    pendingConsent = allowed;
    if (!privacyApi || typeof privacyApi.setTrackingConsent !== 'function') {
      saveFallbackConsent(allowed);
      hideBanner();
      return;
    }

    setButtonsDisabled(true);

    var completed = false;
    var timeoutId;
    function completeConsent(result) {
      if (completed) return;
      completed = true;
      window.clearTimeout(timeoutId);
      setButtonsDisabled(false);
      if (result && result.error) {
        showBanner();
        return;
      }
      pendingConsent = null;
      saveFallbackConsent(allowed);
      hideBanner();
    }

    // A timeout is not proof that Shopify saved the choice; allow a retry.
    timeoutId = window.setTimeout(function () {
      completeConsent({ error: 'Consent request timed out' });
    }, 2000);
    try {
      privacyApi.setTrackingConsent({
        analytics: allowed,
        marketing: allowed,
        preferences: allowed
      }, completeConsent);
    } catch (error) {
      completeConsent({ error: true });
    }
  }

  acceptButton && acceptButton.addEventListener('click', function () {
    saveConsent(true);
  });

  rejectButton && rejectButton.addEventListener('click', function () {
    saveConsent(false);
  });

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    if (hasFallbackConsent()) hideBanner();
    else showBanner();
    return;
  }

  window.Shopify.loadFeatures([
    { name: 'consent-tracking-api', version: '0.1' }
  ], function (error) {
    if (error || !window.Shopify.customerPrivacy) {
      if (hasFallbackConsent()) hideBanner();
      else showBanner();
      return;
    }

    privacyApi = window.Shopify.customerPrivacy;
    if (pendingConsent !== null) {
      saveConsent(pendingConsent);
      return;
    }
    var shouldShowForRegion = typeof privacyApi.shouldShowBanner === 'function'
      && privacyApi.shouldShowBanner();

    if (shouldShowForRegion || (!hasShopifyConsentDecision() && !hasFallbackConsent())) {
      showBanner();
    } else {
      hideBanner();
    }
  });
})();
